export default {
 
    data(){
        return{
            currentTime: null
        }
    },          
    watch:{
      // currentTime(){
      //   console.log('watch currentitme', this.currentTime)
      //   let _this = this
      //   if (_this.getCurrentServerTime){
      //     _this.getCurrentServerTime()
      //   }
      // }
    },
    methods:{        
        currentServerTime(){
          let _this = this           
               

          _this.get('server_time', 
              {},
              function (response) {
                
                // console.log(response.data.time)            
                if (response.data.status === true){
                  _this.currentTime = response.data.time;   
                  // this.$store.state.currentServerTime = response.data.time;                  
                } else {
                  _this.currentTime = null;  
                  // this.$store.state.currentServerTime = null      
                }                
                
              }, function (error) {
                //error                
                console.log('error', error) 
                _this.currentTime = null ;     
                // this.$store.state.currentServerTime = null            
              }
          )      
                    
        }, 
        moment: function (date) {
          return this.$moment(date);
        },
        date: function (date) {
          return this.$moment(date).format('YYYY-MM-DD hh:mm:ss');
        }
            
    }
}